import { useState, useEffect, useRef } from 'react';
import './index.css';

function SelectBox({projects, handleChecked, handleCheckAllProject}){
  const [statusDropdown, setStatusDropdown] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
      
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setStatusDropdown(false);
      }
    }
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [ref]);

  function dropdown(){
      setStatusDropdown(!statusDropdown);
  }

  const isCheckAllProject = () => {
    for(let i = 0; i < projects.length; i++){
      if(projects[i].checked === false){
        return false;
      }
    }
    return true;
  }

  const displayContent = () => {
    let str = '';
    let count = 0;
    let name = []
    for(let i = 0; i < projects.length; i++){
      if(projects[i].checked === true){
        name.push(projects[i].name)
        count++;
      }
    }
    str = name.join(', ');
    if(count === projects.length){
      str = 'Tất cả dự án';
    }
    if(name.length === 0){
      str = 'Chọn dự án'
    }
    return str;
  }
  
  return (
    <>  
      <div className="dropdown" ref={ref}>
        <div onClick={dropdown} className='title'> <img src="./dashboard/project.svg"></img><div className="content_name_project">{displayContent()}</div><img className="img_right" src="./dashboard/Vector_dropdown.svg"></img></div>
        {statusDropdown&&
        <div className="dropdown-content">
          <input type="checkbox" id="all-project" name="project-1" checked={isCheckAllProject()} onChange={() => {}} onClick={() => {
            handleCheckAllProject(!isCheckAllProject())
          }}/>
          <label htmlFor="all-project">Tất cả dự án</label> 
          {projects.map((project, index) => {
            return (
              <div key={index}>
                <input type="checkbox" id={index} name={index} checked={project.checked} onChange={() => {}} onClick={() => {
                  handleChecked(index);
                  }}/>
                <label htmlFor={index}>{project.name}</label> 
              </div>
            )
          })}
        </div>  
        }
      </div>
    </>
  );
}

export default SelectBox;